import pluralize from '@sravni/utils/lib/pluralize';

export const getMonthPluralize = (value: number) => pluralize(value, 'месяц', 'месяца', 'месяцев') ?? 'месяц';
